var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchlummerzeit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "16.7583mm",
    height: "16.9335mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 254 256",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_x0020_-_x0020_Schlummerzeit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M179 251c-22,0 -42,-10 -55,-27 -11,-15 -16,-33 -14,-51 2,-19 12,-35 27,-47 12,-9 26,-14 42,-14 1,0 2,0 3,0l-3 0c-16,0 -30,5 -42,14 -31,24 -36,67 -13,98 13,17 33,27 55,27 15,0 30,-5 42,-15 5,-3 9,-7 12,-12l3 -2c-4,5 -9,10 -15,14 -12,10 -27,15 -42,15 0,0 0,0 0,0zm5 -67l0 0 0 -72c20,2 38,11 50,27 11,15 16,33 14,51 -2,11 -6,21 -11,30l-53 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M190 118c15,3 30,11 40,24 10,14 15,31 12,48 -1,8 -3,15 -7,22l-45 -31 0 -63zm-11 -11l0 0c-16,0 -32,5 -46,15 -32,25 -39,72 -13,105 14,19 36,29 59,29 16,0 32,-5 45,-15 33,-25 39,-72 14,-105 -15,-19 -37,-29 -59,-29zm0 139l0 0c-19,0 -38,-9 -51,-25 -22,-29 -16,-69 12,-90 11,-9 25,-14 39,-14 0,0 0,0 0,0l0 70 50 34c-3,4 -7,8 -11,11 -12,9 -25,14 -39,14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 133l25 -33c3,-3 5,-6 8,-9l0 0 -31 0 0 -8 43 0 0 6 -25 33c-3,3 -5,6 -7,8l0 1 32 0 0 8 -45 0 0 -6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M29 219l23 -29c2,-3 4,-5 6,-8l0 0 -27 0 0 -7 38 0 0 5 -22 29c-2,3 -4,5 -6,8l0 0 28 0 0 7 -40 0 0 -5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M76 67l33 -44c4,-4 7,-8 10,-12l0 0 -40 0 0 -11 57 0 0 8 -34 44c-3,4 -6,8 -9,12l0 0 43 0 0 11 -60 0 0 -8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchlummerzeit);
export default __webpack_public_path__ + "static/media/Schlummerzeit.cf9974c058238da9412da9f4d49699ae.svg";
export { ForwardRef as ReactComponent };